import type { PropsWithChildren } from 'react'

import { cn } from '@/lib/cn'

interface SnackbarViewportProps extends PropsWithChildren {
  placement?: 'top' | 'bottom' | 'top-right'
  className?: string
}

export function SnackbarViewport({
  placement = 'top',
  className,
  children,
}: SnackbarViewportProps) {
  return (
    <div
      className={cn(
        'pointer-events-none fixed z-[1100] w-[min(calc(100%-2rem),23rem)]',
        placement === 'top-right' ? '' : 'left-1/2 -translate-x-1/2',
        className,
      )}
      style={
        placement === 'bottom'
          ? { bottom: 'max(1rem, env(safe-area-inset-bottom))' }
          : {
              top: 'max(1rem, env(safe-area-inset-top))',
              ...(placement === 'top-right'
                ? { right: 'max(1rem, env(safe-area-inset-right))' }
                : {}),
            }
      }
    >
      {children}
    </div>
  )
}
